import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/infrastructure/components/CompanyProfile/CompanyProfile.tsx");
